import { useState } from "react";
import { Link } from "react-router-dom";

const SUPPORT_EMAIL = "info@contentourbonaire.com";
const SUPPORT_PHONE = "+31 652 532 314";

export default function Support() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(
      form.subject ? `[Support] ${form.subject}` : "[Support] Contentour Bonaire"
    );
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`
    );
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
  };

  return (
    <div>
      {/* Hero */}
      <div className="relative bg-[#1a7b7b]">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div
            className="absolute -top-10 -right-10 w-52 md:w-72 opacity-80"
            style={{
              background:
                "linear-gradient(135deg, #a8edea 0%, #fed6e3 40%, #c3f0e8 70%, #b8d4f8 100%)",
              borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70%",
              height: "220px",
              filter: "blur(2px)",
            }}
          />
          <div
            className="absolute -bottom-10 -left-10 w-40 md:w-56 opacity-50"
            style={{
              background:
                "linear-gradient(135deg, #c3f0e8 0%, #a8edea 50%, #fed6e3 100%)",
              borderRadius: "70% 30% 30% 70% / 70% 70% 30% 30%",
              height: "180px",
              filter: "blur(2px)",
            }}
          />
        </div>
        <div className="container mx-auto px-4 py-14 md:py-20 flex flex-col items-center gap-4 relative z-10">
          <div className="flex flex-wrap items-center justify-center gap-1 text-white/70 font-manrope-regular text-sm">
            <Link to="/" className="hover:text-white transition-colors">
              Home
            </Link>
            <span>/</span>
            <span className="text-white">Support</span>
          </div>
          <h1 className="font-manrope-bold text-[28px] md:text-[48px] text-white text-center">
            Contact Support
          </h1>
          <p className="font-manrope-regular text-sm text-white/70 text-center max-w-md">
            Need help? Send us a message and our team will get back to you
            within 1&ndash;2 business days.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="bg-bg py-12 md:py-16">
        <div className="container mx-auto px-4 max-w-5xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Contact cards */}
            <div className="md:col-span-1 flex flex-col gap-4">
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                className="bg-white rounded-[8px] p-5 flex flex-col gap-2 hover:shadow-md transition-shadow"
              >
                <span className="font-manrope-regular text-sm text-black/50">
                  Email us
                </span>
                <span className="font-manrope-semibold text-base text-[#1a7b7b] break-all">
                  {SUPPORT_EMAIL}
                </span>
              </a>

              <a
                href={`tel:${SUPPORT_PHONE.replace(/\s+/g, "")}`}
                className="bg-white rounded-[8px] p-5 flex flex-col gap-2 hover:shadow-md transition-shadow"
              >
                <span className="font-manrope-regular text-sm text-black/50">
                  Call us
                </span>
                <span className="font-manrope-semibold text-base text-[#1a7b7b]">
                  {SUPPORT_PHONE}
                </span>
              </a>

              <div className="bg-white rounded-[8px] p-5 flex flex-col gap-2">
                <span className="font-manrope-regular text-sm text-black/50">
                  Hours
                </span>
                <span className="font-manrope-regular text-base text-black">
                  Mon&ndash;Fri, 9:00&ndash;17:00 (AST)
                </span>
              </div>
            </div>

            {/* Contact form */}
            <form
              onSubmit={handleSubmit}
              className="md:col-span-2 bg-white rounded-[8px] p-6 flex flex-col gap-4"
            >
              <h2 className="font-manrope-semibold text-xl text-black">
                Send us a message
              </h2>
              <p className="font-manrope-regular text-sm text-black/60">
                Fill in the form below. Submitting will open your email app
                with your message ready to send to{" "}
                <span className="text-[#1a7b7b]">{SUPPORT_EMAIL}</span>.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <label className="flex flex-col gap-1">
                  <span className="font-manrope-regular text-sm text-black/70">
                    Your name
                  </span>
                  <input
                    name="name"
                    type="text"
                    required
                    value={form.name}
                    onChange={handleChange}
                    className="border border-black/10 rounded-[6px] px-3 py-2 font-manrope-regular text-base focus:outline-none focus:border-[#1a7b7b]"
                  />
                </label>

                <label className="flex flex-col gap-1">
                  <span className="font-manrope-regular text-sm text-black/70">
                    Your email
                  </span>
                  <input
                    name="email"
                    type="email"
                    required
                    value={form.email}
                    onChange={handleChange}
                    className="border border-black/10 rounded-[6px] px-3 py-2 font-manrope-regular text-base focus:outline-none focus:border-[#1a7b7b]"
                  />
                </label>
              </div>

              <label className="flex flex-col gap-1">
                <span className="font-manrope-regular text-sm text-black/70">
                  Subject
                </span>
                <input
                  name="subject"
                  type="text"
                  required
                  value={form.subject}
                  onChange={handleChange}
                  className="border border-black/10 rounded-[6px] px-3 py-2 font-manrope-regular text-base focus:outline-none focus:border-[#1a7b7b]"
                />
              </label>

              <label className="flex flex-col gap-1">
                <span className="font-manrope-regular text-sm text-black/70">
                  Message
                </span>
                <textarea
                  name="message"
                  rows={6}
                  required
                  value={form.message}
                  onChange={handleChange}
                  className="border border-black/10 rounded-[6px] px-3 py-2 font-manrope-regular text-base focus:outline-none focus:border-[#1a7b7b] resize-y"
                />
              </label>

              <button
                type="submit"
                className="self-start bg-[#1a7b7b] text-white font-manrope-semibold text-base px-6 py-3 rounded-[6px] hover:opacity-90 transition-opacity"
              >
                Send via email
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
